import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import DatePicker from 'react-datepicker';
import Swal from 'sweetalert2';

export const AutoCompleteBox = (props) => {

    const { divclassname = 'col-md-3 mb-1 cntrl-width', style, inputStyle, maxLength, id, label, options, inputValue, onInputChange,
        placeholder, required, error, loading, ignore_common, ...rest } = props
    return (
        <div
            className={`${ignore_common ? '' : divclassname}`}
            style={style}
        >
            {label !== "" ?
                <label className="form-label" htmlFor={id}>{label || ''}
                    {required ? <span style={{ color: "red" }}> *</span> : <></>}
                </label>
                : ''}
            <Autocomplete
                loading={loading}
                inputValue={inputValue}
                onInputChange={onInputChange}
                freeSolo
                autoComplete
                options={options}
                renderInput={(params) => <TextField
                    {...params}
                    onInput={(e) => {
                        const { value } = e.target;

                        if (value.length > maxLength) {
                            e.target.value = value.slice(0, maxLength);
                        }
                    }}
                    sx={inputStyle}
                    placeholder={placeholder}
                    {...rest}
                />}
                {...props}
            />
            {error && <div className="error-msg">{error}</div>}
        </div>
    )
}



export const DateBox = (props) => {
    const { style, label, onKeyDown, maxDate, selected, placeholder, id, inputrefs, onChange, required, } = props
    return (
        <div
            style={style}
        >
            <label className="form-label">{label || 'Branch'}
                {required ? <span style={{ color: "red" }}> *</span> : <></>}

            </label>
            <DatePicker
                className='form-control input-fields'
                dateFormat="dd-MMM-yyyy"
                placeholderText={placeholder}
                selected={selected}
                maxDate={maxDate}
                ref={ref => (inputrefs.current[id] = ref)}
                onKeyDown={onKeyDown}
                onChange={onChange}
                {...props}
            />

        </div>
    )
}

export const AlertBox = (status = '', message = '', focusElementId = '') => {
    if (message !== "No Record Found" && message !== "Record fetched successfully" && message !== undefined && message !== "") {
        Swal.fire({
            text: message,
            icon: status.toLowerCase(),
            title: status.toUpperCase(),
            confirmButtonColor: '#238914',
            allowOutsideClick: false,
            width: 500,
            didClose: () => {
                if (focusElementId !== "")
                    document.getElementById(focusElementId)?.focus();
            }
        }).then((result) => {
            if (result.isConfirmed) {

            }
        });
    }
}
